import { Clipboard } from '@angular/cdk/clipboard';
import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { MatFormField, MatInput } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { CheckboxComponent } from '../../../ui/checkbox/checkbox.component';
import { BaseModalComponent } from '../../base-modal/base-modal.component';
@Component({
  selector: 'mb-shared-download-modal',
  templateUrl: './shared-download-modal.component.html',
  styleUrls: ['./shared-download-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseModalComponent, CheckboxComponent, RouterLink, MatFormField, MatInput, TranslatePipe],
})
export class SharedDownloadModalComponent {
  private clipboard = inject(Clipboard);

  public copied = false;
  public agreed = false;

  @Input() url = '';

  copyUrl() {
    this.clipboard.copy(this.url);
    this.copied = true;
  }
}
